module.exports = __webpack_public_path__ + "static/jason-3ceed8cede11f9e86390e7150eb31867.png";